import { render, staticRenderFns } from "./PersonalPosts.vue?vue&type=template&id=a4c5a6be"
import script from "./PersonalPosts.vue?vue&type=script&lang=js"
export * from "./PersonalPosts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports